{
  "alert": "Uyarı",
  "dismiss": "Kapat"
}